// per https://www.calleerlandsson.com/replacing-sprockets-with-webpacker-for-javascript-in-rails-5-2/
import {createConsumer} from "@rails/actioncable"

export default createConsumer()